import type { ICargoImageUploadPayload } from '~~/shared/interfaces/cargoImage';
import type { ICargoImage } from '~~/shared/interfaces/driverRequests';

export const useCargoImageStore = defineStore('cargo-image', () => {
	const loading = reactive({
		addCargoImage: false,
		deleteCargoimage: false
	});

	function $reset() {}

	const getCargoImagesByCargo = async (
		payload: Pick<ICargoImageUploadPayload, 'cargoId' | 'cargoImageType'>
	) => {
		const response = await useCustomFetch<ICargoImage[]>(
			'/api/CargoImage/get-by-cargo',
			{
				query: payload,
				timeout: 12000,
				watch: false
			}
		);

		return { data: response.data.value, status: response.status.value };
	};

	const uploadCargoImage = async (payload: ICargoImageUploadPayload) => {
		const formData = new FormData();

		formData.append('cargoId', payload.cargoId);
		payload.files.forEach((f) => {
			formData.append('files', f);
		});

		const response = await useCustomFetch<{ status: boolean; msg: string }>(
			'/api/CargoImage/upload',
			{
				method: 'POST',
				query: payload.cargoImageType ? { cargoImageType: payload.cargoImageType } : undefined,
				body: formData
			},
			{
				setLoading: (load: boolean) => {
					if (true) {
						loading.addCargoImage = load;
					}
				}
			}
		);

		return {
			data: response.data.value,
			status: response.status.value,
			offlineRequestId: response.offlineRequestId
		};
	};

	const cargoImageDelete = async (payload: { id: string }) => {
		const response = await useCustomFetch<unknown>(
			'/api/CargoImage/delete',
			{
				method: 'delete',
				query: payload
			},
			{
				setLoading: (load: boolean) => {
					if (true) {
						loading.deleteCargoimage = load;
					}
				}
			}
		);

		return {
			data: response.data.value,
			status: response.status.value,
			offlineRequestId: response.offlineRequestId
		};
	};

	return {
		loading,
		$reset,
		getCargoImagesByCargo,
		uploadCargoImage,
		cargoImageDelete
	};
});
